import axiosClient, { ApiResponse, axiosCustomError } from "./api";

export interface ITTLT_DichVu {
    id: number;
    ten: string;
    donVi: string;
    donGia: number | null;
    suDung: boolean;
    coSoLuuTruId: number;
}

export default class TTLT_DichVuService {
    static async filter(coSoLuuTruId: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/DichVu/Filter/${coSoLuuTruId}?keyword=${keyword}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async getByUsedId(coSoLuuTruId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/DichVu/GetByUsedId/${coSoLuuTruId}/${id}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }
    
    static async filterPagination(coSoLuuTruId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/DichVu/FilterPagination/${coSoLuuTruId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async get(coSoLuuTruId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/DichVu/${coSoLuuTruId}/${id}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async delete(coSoLuuTruId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/DichVu/${coSoLuuTruId}/${id}`, {

            });

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async update(id: number, itemData: ITTLT_DichVu) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/DichVu/${id}`, itemData);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async create(itemData: ITTLT_DichVu) {
        try {
            const { data } = await axiosClient.post<ApiResponse>(`/api/DichVu/Create`, itemData);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async changeIsUsedItem(coSoLuuTruId: number, id: number, suDung: boolean) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/DichVu/ChangeIsUsedItem/${coSoLuuTruId}`, { id, suDung });

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }
}